import React, { useState } from "react";

export const AddBooksForm = ({ userData, setUserData }) => {
	const [currentBooks, setCurrentBooks] = useState("");

	// Handle adding books
	const addBooks = () => {
		if (currentBooks && !userData?.books?.includes(currentBooks)) {
			const updatedBooks = userData?.books ? [...userData?.books, currentBooks] : [currentBooks];
			if (updatedBooks.length > 5) {
				updatedBooks.pop(); // Remove the last books if there are more than 5
			}
			const updatedUserData = { ...userData, books: updatedBooks };
			setUserData(updatedUserData);
			setCurrentBooks(""); // Reset input
		}
	};

	// Handle removing a books
	const removebooks = (booksName) => {
		const currentBooks = userData?.books?.filter((h) => h !== booksName);
		const updatedUserData = { ...userData, books: currentBooks };
		setUserData(updatedUserData);
	};

	return (
		<>
			<label htmlFor="books" className="form-label">
				<i className="bi bi-book"></i> <span>Books</span>
			</label>
			<div className="input-group mb-2">
				<input
					className="form-control"
					value={currentBooks}
					onChange={(e) => setCurrentBooks(e.target.value)}
					maxLength={50}
					placeholder="Type a book you've enjoyed..."
				/>
				<button
					className="btn my-btn d-flex align-items-center justify-content-center"
					onClick={addBooks}
					disabled={!currentBooks || userData?.books?.length >= 5}
					style={{ padding: "0", height: "38px", width: "78px" }}
				>
					<i className="bi bi-plus" style={{ fontSize: "38px" }}></i>
				</button>
			</div>

			<div>
				<ul className="list-group">
					{userData?.books?.map((book, index) => (
						<li
							key={index}
							className="list-group-item d-flex justify-content-between align-items-center"
							style={{ padding: "0 0 0 10px" }}
						>
							<div>
								<i className="bi bi-book me-2"></i>
								{book}
							</div>
							<button
								className="btn btn-danger btn-sm"
								onClick={() => removebooks(book)}
								style={{ padding: "0", height: "30px", width: "30px" }}
							>
								<i className="bi bi-trash"></i>
							</button>
						</li>
					))}
				</ul>
			</div>
		</>
	);
};
